import * as Yup from 'yup';

const authAppTOTPValidationScheme = Yup.object().shape({
	code: Yup.string().min(6).max(6).required(),
});

export default authAppTOTPValidationScheme;
